import React, { createContext, useContext, useState, ReactNode } from "react";

type Toast = { id: number; type: "success" | "error" | "info"; message: string };

type ToastContextType = {
  showSuccess: (msg: string) => void;
  showError: (msg: string) => void;
  showInfo: (msg: string) => void;
};

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const ToastProvider = ({ children }: { children: ReactNode }) => {
  const [toasts, setToasts] = useState<Toast[]>([]);
  const push = (type: Toast["type"], message: string) => {
    const id = Date.now() + Math.floor(Math.random() * 1000);
    const t = { id, type, message };
    setToasts((s) => [t, ...s]);
    setTimeout(() => {
      setToasts((s) => s.filter((x) => x.id !== id));
    }, 5000);
  };

  const ctx: ToastContextType = {
    showSuccess: (m) => push("success", m),
    showError: (m) => push("error", m),
    showInfo: (m) => push("info", m),
  };

  return (
    <ToastContext.Provider value={ctx}>
      {children}
      <div style={{ position: "fixed", right: 16, top: 16, zIndex: 9999 }}>
        {toasts.map((t) => (
          <div
            key={t.id}
            style={{
              marginBottom: 8,
              padding: "10px 14px",
              borderRadius: 6,
              color: "white",
              minWidth: 200,
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              background: t.type === "success" ? "#16a34a" : t.type === "error" ? "#dc2626" : "#0ea5e9",
            }}
          >
            {t.message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error("useToast must be used within ToastProvider");
  return ctx;
};

export default ToastProvider;
